import { takeLatest, put, call, all, fork } from 'redux-saga/effects';
import { getCurrentAccount } from '@adjust/dashboard-core/api/account';
import { getTimezones, updateAccount } from '@api/account';
import {
  DATA_FETCH_STARTED,
  DATA_UPDATE_STARTED,
  fetchDataOk,
  updateDataOk,
  updateDataError,
} from '@redux/ducks/accountDetails';
import { setAccount, setTimezones } from '@redux/ducks/global';

// Watchers

export function* watchFetchData() {
  yield takeLatest(DATA_FETCH_STARTED, fetchDataTask);
}

export function* watchUpdateData() {
  yield takeLatest(DATA_UPDATE_STARTED, fetchUpdateTask);
}

// Workers

export function* fetchDataTask(action) {
  try {
    const forceUpdate = action?.payload?.forceUpdate || false;

    const [account, timezones] = yield all([call(getCurrentAccount, { forceUpdate }), call(getTimezones)]);

    yield put(setAccount(account));
    yield put(setTimezones(timezones));
    yield put(fetchDataOk());
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }
}

export function* fetchUpdateTask({ payload }) {
  try {
    const { id, data } = payload;
    const resp = yield call(updateAccount, id, data);

    // TODO: Remove me when we connect accountDetails tile is connected to store
    yield fork(getCurrentAccount, { forceUpdate: true });

    yield put(setAccount(resp));
    yield put(updateDataOk());
  } catch (err) {
    yield put(updateDataError());
  }
}

// Saga

export default function* accountDetailsSaga() {
  yield all([watchFetchData(), watchUpdateData()]);
}
